export default function normalizeString(value: string | number) {
    if (!value) {
        return;
    }
    const str = String(value);
    // eslint-disable-next-line consistent-return
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeCityName(value: string): string {
    if (!value) return '';

    return (value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/['’`´-]/g, ' ')
        .trim()
        .toUpperCase();
}

export function formatCurrency(str: any) {
    return str?.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
    });
}

export function centsToDecimalString(cents: number): string {
    if (!Number.isFinite(cents) || cents < 0) {
        throw new Error(`Valor em centavos inválido para pagamento: ${cents}`);
    }
    return (Math.round(cents) / 100).toFixed(2).replace('.', ',');
}

export function formatPercentage(value: string) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(parseFloat(value) / 100);
}

export function formatToQueryParam(str: any) {
    return str.replace(/[*+\\()?]/, '');
}
